import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <g>
                    <path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7Z" />
                    <rect x="33.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M71.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S42.4,99.8,45,104.5s10.7,5.4,18,1.6S73.9,95.4,71.2,90.7Z" />
                    <rect x="70.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M109.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S80.4,99.8,83,104.5s10.7,5.4,18,1.6S111.9,95.4,109.2,90.7Z" />
                    <rect x="108.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M146.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4,10.7,5.4,18,1.6S148.9,95.4,146.2,90.7Z" />
                    <rect x="145.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="33" y="23" width="114" height="10" />
                <rect x="33" y="37" width="114" height="10" />
            </g>
            <g>
                <g>
                    <path d="M184.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4,10.7,5.4,18,1.6S186.9,95.4,184.2,90.7Z" />
                    <rect x="183.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="126" y="23" width="59" height="10" />
            </g>
        </svg>
    );
}
